module.exports = __webpack_public_path__ + "static/media/400137_02.6f975cdf.png";